import React from 'react';
import PropTypes from 'prop-types';

import { Cover, Image, Layout, Link, SectionFAQs, SEO, SectionReviewModals } from 'components';
import { routes } from 'utils/routes';
import { cta } from 'utils/cta';
import { media } from 'utils/media';

import contentSeo from "cms/content/faqs-seo.yml";
import contentCover from "cms/content/faqs-cover.yml";
import contentSecReviewModals from "cms/content/faqs-section-review-modals.yml";


const FAQPage = ({ pageContext: { locale }, location }) => (
  <Layout locale={locale}>
    <SEO
      title={contentSeo.title}
      description={contentSeo.description}
      lang={locale}
      keywords={contentSeo.keywords}
      location={location}
      image={contentSeo.socialImage}
    />

    <Cover
      title={contentCover.title}
      image={{ url: media(contentCover.image), alt: 'Teeth straightening FAQS' }}
      button={{ label: cta.eConsultation, ...routes.getStarted }}
      overlap
    />

    <SectionFAQs locale={locale} />

    <h3 className='section-title mt-90 mb-50'>The only aligner service to guarantee results, with no hidden costs.</h3>
    <div className='flex-center'>
      <div className='flex-center flex-col mr-40'>
        <Image url='icons/icon_blog.svg' alt='Teeth straightening blog' />
        <p className='mt-20 mb-20 t-center'><b>Find tons of content<br/>on our blog</b></p>
        <Link to={routes.blog.path} {...routes.blog} className='button outline'>Visit the blog</Link>
      </div>
      <div className='flex-center flex-col ml-40'>
        <Image url='icons/icon_answer.svg' alt='Can’t find your answer?' />
        <p className='mt-20 mb-20 t-center'><b>Can't find<br/>your answer?</b></p>
        <Link to={routes.contacts.path} {...routes.contacts} className='button outline'>Contact us</Link>
      </div>
    </div>

    <SectionReviewModals content={contentSecReviewModals} />

  </Layout>
);

FAQPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

export default FAQPage;
